export const ARDOQ_ID_LENGTH = 24;

export const ardoqId = (): string => {
  // eslint-disable-next-line no-restricted-syntax
  const dateInHexCode = new Date().getTime().toString(16);
  return [
    dateInHexCode,
    ...Array(ARDOQ_ID_LENGTH - dateInHexCode.length)
      .fill('')
      .map(() => Math.floor(Math.random() * 16).toString(16)),
  ].join('');
};
